// extracted by css-extract-rspack-plugin
export default {"tableBox":"tableBox-iSHOyr"};